import React from "react";
import "./TaxCalculator.css";
import RedArrow from "../Assets/RedArrow.svg";
import GreenArrow from "../Assets/GreenArrow.svg";
import Vector from "../Assets/Vector (1).svg";

const TaxCalculator = ({ apiData, values }) => {
  const { comparison, totalTax_2023_24, totalTax_2022_23 } = apiData;
  const fallbackUrl = values?.fallBackUrl;

  const getIcon = (tax_2023_24, tax_2022_23, key) => {
    if (tax_2023_24 === tax_2022_23) {
      return null;
    }
    if (key === "0 to 25" && apiData.taxRegime === "old") {
      return (
        <img
          src={GreenArrow}
          alt="NIL"
          style={{
            width: "16px",
            height: "16px",
            marginLeft: "4px",
            display: "inline",
          }}
        />
      );
    }
    return tax_2023_24 > tax_2022_23 ? (
      <img
        src={RedArrow}
        alt="Increase"
        style={{
          width: "16px",
          height: "16px",
          marginLeft: "4px",
          display: "inline",
        }}
      />
    ) : (
      <img
        src={GreenArrow}
        alt="Decrease"
        style={{
          width: "16px",
          height: "16px",
          marginLeft: "4px",
          display: "inline",
        }}
      />
    );
  };

  const convertRange = (range) => {
    const [start, end] = range
      .split(" to ")
      .map((num) => parseInt(num) * 10000);
    if (isNaN(start) || isNaN(end)) {
      return range;
    }
    return `₹${start.toLocaleString()} to ₹${end.toLocaleString()}`;
  };

  const formatRange = (key) => {
    if (apiData.taxRegime === "old" && key === "0 to 30") {
      return "Up to ₹3,00,000";
    }
    return key === "0 to 40" ? "Up to ₹4,00,000" : convertRange(key);
  };

  let firstSlabUpperLimit = 400000;
  if (apiData.taxRegime === "old") {
    firstSlabUpperLimit = 300000;
  }
  let netTaxableIncome = apiData.annualIncome - firstSlabUpperLimit;

  if (netTaxableIncome < 0) {
    netTaxableIncome = 0;
  }

  return (
    <div className="tax-calculator">
      <h2>Income Tax Calculation</h2>
      <p>Income tax for a CTC of ₹{apiData.annualIncome.toLocaleString()}</p>
      <div className="tax-slabs">
        {Object.keys(comparison).map((key) => (
          <div className="tax-slab" key={key}>
            <span className="tax-slab-income">{formatRange(key)}</span>
            <div className="tax-slab-result">
              <div>
                {key === "0 to 25"
                  ? "NIL"
                  : `${comparison[key].tax_rate_2025_26}%`}{" "}
                {getIcon(
                  comparison[key].tax_2023_24,
                  comparison[key].tax_2022_23,
                  key
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="net-taxable-income">
        <span>Net Taxable Income: ₹{netTaxableIncome.toLocaleString()}</span>
      </div>
      <div className="tax-summary">
        <div className="total-income-tax">
          <span>
            Total Income Tax:{" "}
            <strong>₹{totalTax_2023_24.toLocaleString()}</strong>{" "}
            {getIcon(totalTax_2023_24, totalTax_2022_23, "total")}
          </span>
        </div>
        <div className="final-note">
          <p>
            Final tax depends on your investment in various financial
            instruments
          </p>
        </div>
      </div>
      <p className="disclaimer">
        Disclaimer: This utility provides an approximate tax calculation for
        entertainment purposes only. For accurate tax advice, please consult a
        certified accountant (CA).
      </p>
      <div className="more-details">
        <p>To know more details, visit:</p>
        {fallbackUrl && (
          <a href={fallbackUrl} target="_blank" rel="noopener noreferrer">
            {fallbackUrl}
          </a>
        )}
        <img src={Vector} alt="Details" className="more-details-icon" />{" "}
        {/* Add the SVG icon */}
      </div>
    </div>
  );
};

export default TaxCalculator;
